import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { COMPANY_INFO, MENU_ITEMS } from '../data/scrapedData';

export function Footer() {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    website_url: '' // Honeypot field
  });
  const [status, setStatus] = useState({ type: null, message: '' });
  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(false);
  };

  return (
    <footer id="kontakt" className="bg-[#1C1C1E] text-white pt-16 pb-8 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Navigation & Links */}
        <div className="py-12 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-8 text-sm border-b border-white/10">
          
          {/* Main Items */}
          <div>
            <h4 className="text-white font-bold mb-4 text-base tracking-wide">
              Hovedmenu
            </h4>
            <ul className="space-y-2.5">
              {MENU_ITEMS.map(item => (
                <li key={item.path}>
                  <Link to={item.path} className="text-white/70 hover:text-white transition-colors">
                    {item.title}
                  </Link>
                </li>
              ))}
              <li>
                <a href="#kontakt" className="text-white/70 hover:text-white transition-colors">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          {/* Treatment Links 1 */}
          <div>
            <h4 className="text-white font-bold mb-4 text-base tracking-wide">
              Behandling
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/behandling" className="text-white/70 hover:text-white transition-colors">
                  Oversigt over behandling
                </Link>
              </li>
              <li>
                <Link to="/behandling/afgiftning" className="text-white/70 hover:text-white transition-colors">
                  Afgiftning
                </Link>
              </li>
              <li>
                <Link to="/behandling/primaerbehandling" className="text-white/70 hover:text-white transition-colors">
                  Primærbehandling
                </Link>
              </li>
              <li>
                <Link to="/dobbeltdiagnose" className="text-white/70 hover:text-white transition-colors">
                  Dobbeltdiagnose
                </Link>
              </li>
              <li>
                <Link to="/botilbud" className="text-white/70 hover:text-white transition-colors">
                  Botilbud
                </Link>
              </li>
              <li>
                <Link to="/behandling/tilbagefaldsbehandling-og-forebyggelse" className="text-white/70 hover:text-white transition-colors">
                  Tilbagefaldsbehandling
                </Link>
              </li>
            </ul>
          </div>

          {/* Treatment Links 2 & Facilities */}
          <div>
            <h4 className="text-white font-bold mb-4 text-base tracking-wide">
              Afdelinger & Rammer
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/midtgaarden-i-sejstrup" className="text-white/70 hover:text-white transition-colors">
                  Midtgaarden i Sejstrup
                </Link>
              </li>
              <li>
                <Link to="/halvvejshuset-i-esbjerg" className="text-white/70 hover:text-white transition-colors">
                  Halvvejshuset i Esbjerg
                </Link>
              </li>
              <li>
                <Link to="/behandling/eftervaern-og-udslusning" className="text-white/70 hover:text-white transition-colors">
                  Udslusning og halvvejshus
                </Link>
              </li>
              <li>
                <Link to="/tilsyn" className="text-white/70 hover:text-white transition-colors">
                  Godkendelser og tilsyn
                </Link>
              </li>
              <li>
                <Link to="/priser" className="text-white/70 hover:text-white transition-colors">
                  Priser
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact & Socials */}
          <div>
            <h4 className="text-white font-bold mb-4 text-base tracking-wide">
              Kontakt & Sociale Medier
            </h4>
            <div className="space-y-3 text-xs text-white/80 mb-6">
              <p>
                <strong>{COMPANY_INFO.name}</strong><br />
                {COMPANY_INFO.address}
              </p>
              <p className="whitespace-nowrap">
                Tlf: <a href={COMPANY_INFO.phoneTel} className="text-[#3885B8] hover:underline whitespace-nowrap">{COMPANY_INFO.phone}</a>
              </p>
              <p className="whitespace-nowrap">
                Mail: <a href={COMPANY_INFO.emailMailto} className="text-[#3885B8] hover:underline whitespace-nowrap">{COMPANY_INFO.email}</a>
              </p>
            </div>

            <div className="flex items-center gap-3">
              {COMPANY_INFO.instagram && (
                <a
                  href={COMPANY_INFO.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Følg Midtgaarden på Instagram"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#3885B8] text-white flex items-center justify-center transition-colors text-sm"
                  title="Instagram"
                >
                  <i className="fa-brands fa-instagram" aria-hidden="true" />
                </a>
              )}

              {COMPANY_INFO.facebook && (
                <a
                  href={COMPANY_INFO.facebook}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Følg Midtgaarden på Facebook"
                  className="w-9 h-9 rounded-full bg-white/10 hover:bg-[#3885B8] text-white flex items-center justify-center transition-colors text-sm"
                  title="Facebook"
                >
                  <i className="fa-brands fa-facebook-f" aria-hidden="true" />
                </a>
              )}
            </div>
          </div>

        </div>

        {/* Bottom Bar & Copyright */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/60">
          <p>
            © {new Date().getFullYear()} {COMPANY_INFO.name}. Alle rettigheder forbeholdes.
          </p>
          <p className="text-white/50">
            Selvejende behandlings- og botilbud – Bramming & Esbjerg
          </p>
        </div>

      </div>
    </footer>
  );
}
